module.exports = __webpack_public_path__ + "img/galerie-21.2e4372e1.jpg";